import { createContext, useContext, useState, useCallback } from "react";

export type ModalType = "quote" | "demo" | null;

interface ModalContextType {
  modalType: ModalType;
  openQuote: () => void;
  openDemo: () => void;
  closeModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export function ModalProvider({ children }: { children: React.ReactNode }) {
  const [modalType, setModalType] = useState<ModalType>(null);

  const openQuote = useCallback(() => setModalType("quote"), []);
  const openDemo = useCallback(() => setModalType("demo"), []);
  const closeModal = useCallback(() => setModalType(null), []);

  return (
    <ModalContext.Provider value={{ modalType, openQuote, openDemo, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModal() {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error("useModal must be used within ModalProvider");
  return ctx;
}